import {colors} from './colors'

export const checkboxStyling = {
  marginRight: '10px',
  padding: '0px',
  '&.Mui-focusVisible': {
    outline: `2px solid ${colors.blue1}`,
    borderRadius: '5px',
  },
}